<section class="eventq-camera-list-panel">
  <eventq-searchable-list
    appearance="camera"
    selectionMode="multiple"
    [selectable]="false"
    [fillHeight]="true"
    [columns]="cameraColumns"
    [rows]="cameraRows()"
    [searchQuery]="searchQuery()"
    [searchPlaceholder]="searchPlaceholder()"
    listAriaLabel="Cameras"
    (searchQueryChange)="searchQueryChange.emit($event)"
    (rowAction)="onRowAction($event)"
  >
    <div eventqSearchableListExtra class="eventq-camera-list-panel__open-all">
      <eventq-button
        label="Open All Cameras"
        variant="primary-outline"
        size="sm"
        (pressed)="openAll.emit()"
      />
    </div>
  </eventq-searchable-list>
</section>
